export const MIN_YEAR_PERENCANAAN_V2 = 2026
